<template>
    <kgr-table
        :is-data-table="false"
    >
        <tr class="kgr-table__row toggleReceiver" @click="showReceiverList = !showReceiverList">
            <kgr-th class="headline_action">
                <kgr-icon :icon-class="iconClass" />
            </kgr-th>
            <kgr-th class="headline_date">
                <div>{{ mailHistory.date }}</div>
                <div>{{ mailHistory.time }}</div>
            </kgr-th>
            <kgr-th class="headline_info">
                <div>{{ $t('Betreff:') }} <span class="bold">{{ mailHistory.subject }}</span></div>
                <div>{{ $t('Von:') }} {{ mailHistory.senderName }}</div>
                <div v-if="mailHistory.cc">
                    {{ $t('CC:') }} {{ mailHistory.cc }}
                </div>
                <div v-if="mailHistory.bcc">
                    {{ $t('BCC:') }} {{ mailHistory.bcc }}
                </div>
            </kgr-th>
            <kgr-th class="headline_counter">
                Empfänger: {{ mailHistory.countReceiver }}
            </kgr-th>
        </tr>
        <tr class="kgr-table__row is-inactive" v-if="showReceiverList">
            <td></td>
            <td></td>
            <td colspan="2" class="kgr-table__cell">
                <kgr-receiver-list :mail-history-id="mailHistory.id" />
            </td>
        </tr>
        <tr colspan="4" class="kgr-row">
&nbsp;
        </tr>
    </kgr-table>
</template>

<script>
import Icon from '../common/icon/Icon.vue';
import ReceiverList from './ReceiverList.vue';

export default {
    components: {
        'kgr-receiver-list': ReceiverList,
        'kgr-icon': Icon,
    },
    props: {
        mailHistory: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            showReceiverList: false,
        };
    },
    computed: {
        iconClass() {
            return this.showReceiverList ? 'arrow-down' : 'arrow-right';
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.bold {
    font-weight: var(--kgr-font-weight-bold);
}
.headline_action,
.headline_date,
.headline_counter {
    white-space: nowrap;
    vertical-align: top;
}
.headline_date {
    text-align: center;
}
.headline_info {
    width: 90%;
}
.headline_counter {
    width: 10%;
}
.toggleReceiver {
    cursor: pointer;
}
</style>
